import { createAction } from '@sde/widgets-core/src/redux/helpers/createAction';
import {
  SET_BREADCRUMBS,
  REMOVE_BREADCRUMB,
  REMOVE_BREADCRUMBS,
} from './constants';

export const setBreadcrumbs = (payload) => {
  return createAction({
    type: SET_BREADCRUMBS,
    payload,
  });
};

export const removeBreadcrumb = (payload) => {
  return createAction({
    type: REMOVE_BREADCRUMB,
    payload,
  });
};

export const removeBreadcrumbs = (payload) => {
  return createAction({
    type: REMOVE_BREADCRUMBS,
    payload,
  });
};
